var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-rounded-full tw-bg-gray-300 tw-text-sm tw-ml-3 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center"},[_vm._v(" "+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }